// extracted by mini-css-extract-plugin
export default {"p_tye":"_125ea36c0c","slcted":"_934726000b","slc_color":"_8dcc4711a4","item_p":"bd9df27508","r0":"_9d7622ca91"};